import React from 'react';

import type { DepositRegistration } from '@/types/database/depositRegistration';

import { useDepositListContext } from '../../../../context';
import { checkIsShowRobotDeliveryButton } from './helpers';
import styles from './index.module.scss';

type CheckDetailAndRobotDeliveryButtonsProps = {
  deposit: DepositRegistration;
};

const CheckDetailAndRobotDeliveryButtons = ({
  deposit,
}: CheckDetailAndRobotDeliveryButtonsProps) => {
  const { setViewPostal, setIsShowDepositDetailModal, setRobotDeliveryDialog } =
    useDepositListContext();

  const isShowRobotDeliveryButton = checkIsShowRobotDeliveryButton(deposit);

  return (
    <div className={styles.buttons}>
      <button
        className={styles.checkDetailButton}
        onClick={() => {
          setViewPostal(deposit);
          setIsShowDepositDetailModal(true);
        }}
      >
        查看更多
      </button>
      {isShowRobotDeliveryButton ? (
        <>
          <div className={styles.divider} />
          <button
            className={styles.robotDeliveryButton}
            onClick={() => {
              setViewPostal(deposit);
              setRobotDeliveryDialog(true);
            }}
          >
            機器人派送
          </button>
        </>
      ) : null}
    </div>
  );
};

export default CheckDetailAndRobotDeliveryButtons;
